import { useState } from "react";
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp} from 'react-icons/md'

function Notification() {
    const [opened, setOpened] = useState(null)
  return (
    <div className="w-[33.375rem] h-[24.25rem] shadow-[0px_4px_4px_1px_rgba(0,0,0,0.25)] bg-white pt-6 p-2 z-10 overflow-y-scroll">
      <div className="border-b-4 flex justify-between px-12 py-3 text-[1.125rem] font-[600] ">
        <div className="flex gap-3 items-center -mb-4 border-b-4 pb-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M12.5 1.5625C6.46875 1.5625 1.5625 6.46875 1.5625 12.5C1.5625 18.5312 6.46875 23.4375 12.5 23.4375C18.5312 23.4375 23.4375 18.5312 23.4375 12.5C23.4375 6.46875 18.5312 1.5625 12.5 1.5625ZM12.5 19.782C11.2078 19.782 10.1562 18.7305 10.1562 17.4383C10.1562 16.1461 11.2078 15.0945 12.5 15.0945C13.7922 15.0945 14.8438 16.1461 14.8438 17.4383C14.8438 18.7305 13.7922 19.782 12.5 19.782ZM14.5398 13.1437C14.4805 13.7477 13.9789 14.2016 13.3734 14.2016H11.6273C11.0219 14.2016 10.5203 13.7469 10.4609 13.1445L9.85391 6.93125C9.81094 6.49375 9.95547 6.05547 10.2516 5.72969C10.5469 5.40391 10.9688 5.21719 11.4086 5.21719H13.5922C14.032 5.21719 14.4547 5.40391 14.7492 5.72969C15.0445 6.05547 15.1898 6.49375 15.1469 6.93203L14.5398 13.1437Z"
              fill="#B1B1B4"
            />
            <path
              d="M13.5914 5.21802H11.4078C10.968 5.21802 10.5453 5.40474 10.2508 5.73052C9.95546 6.0563 9.81015 6.49458 9.85312 6.93208L10.4601 13.1454C10.5195 13.7477 11.0211 14.2024 11.6266 14.2024H13.3726C13.9781 14.2024 14.4797 13.7477 14.5391 13.1446L15.1461 6.93286C15.1891 6.49458 15.0445 6.05708 14.7484 5.73052C14.4539 5.40474 14.032 5.21802 13.5914 5.21802Z"
              fill="white"
            />
            <path
              d="M12.5 19.782C13.7944 19.782 14.8438 18.7326 14.8438 17.4382C14.8438 16.1438 13.7944 15.0945 12.5 15.0945C11.2056 15.0945 10.1562 16.1438 10.1562 17.4382C10.1562 18.7326 11.2056 19.782 12.5 19.782Z"
              fill="white"
            />
          </svg>
          <span className="text-[#B1B1B4]">Required Actions</span>
        </div>
        <div className="flex gap-3 items-center border-b-4 border-[#2817E9] -mb-4 pb-3">
          <span className=" w-[2.3125rem] h-[1.4375rem] bg-[#2817E9] text-white rounded-[1.25rem] text-[0.75rem] flex items-center justify-center shrink-0 font-[500] leading-3">
            12
          </span>

          <span>Notifications</span>
        </div>
      </div>

      {/* Prescriptions */}
      <div className=" border-b-4 ">
        <div className="flex gap-3 w-full py-3 px-2 items-center cursor-pointer" onClick={ () => {opened === 'prescriptions' ? setOpened(null) : setOpened('prescriptions') }}>
          <span className=" w-[2.3125rem] h-[1.4375rem] bg-[#2817E9] text-white rounded-[1.25rem] text-[0.75rem] flex items-center justify-center shrink-0 font-[500] leading-3">
            2
          </span>
          <span className="text-[1rem] font-[500] w-[80%] leading-4 capitalize">
            Prescriptions
          </span>
          <span className=" leading 1">
           {opened === 'prescriptions' ? <MdOutlineKeyboardArrowUp  size={30}/> : <MdOutlineKeyboardArrowDown  size={30}/>}
          </span>
        </div>
       {opened === 'prescriptions' && <div className="flex gap-6 py-6">
          <div className="w-[20%] flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                stroke="#2817E9"
                strokeWidth="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                stroke="#2817E9"
                strokeWidth="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className="w-[21.5rem]">
            <p className="text-xs font-medium">
              You have added a new appointment for
              <span className="underline text-[#009FE3] cursor-pointer">
                {" "}
                ADETUNJI, TOBI
              </span>{" "}
              for{" "}
              <span className="underline text-[#009FE3] cursor-pointer">
                AXA Mansard
              </span>
            </p>
            <p className="my-3 text-xs font-medium">
              Click here to get further information.
            </p>
            <p className="text-base font-medium underline text-[#009FE3] cursor-pointer">
              View information
            </p>
            <div className="flex mt-3 items-center gap-[0.5rem]">
            <button className="text-white bg-[#009FE3] w-[4.5625rem] rounded-[2.5rem] shrink-0 text-xs font-normal leading-[1.25rem]  ">Accept</button>
            <button className="text-black bg-[#E1E8EC] w-[4.5625rem] rounded-[2.5rem] shrink-0 text-xs font-normal leading-[1.25rem]  ">Reject</button>
            </div>
          </div>
        </div>}
      </div>

        {/* Patients */}
      <div className=" border-b-4 ">
        <div className="flex gap-3 w-full py-3 px-2 items-center cursor-pointer" onClick={ () => {opened === 'patients' ? setOpened(null) : setOpened('patients') }}>
          <span className=" w-[2.3125rem] h-[1.4375rem] bg-[#2817E9] text-white rounded-[1.25rem] text-[0.75rem] flex items-center justify-center shrink-0 font-[500] leading-3">
            2
          </span>
          <span className="text-[1rem] font-[500] w-[80%] leading-4 capitalize">
            patients
          </span>
          <span className=" leading 1">
           {opened === 'patients' ? <MdOutlineKeyboardArrowUp  size={30}/> : <MdOutlineKeyboardArrowDown  size={30}/>}
          </span>
        </div>
       {opened === 'patients' && <div className="flex gap-6 py-6">
          <div className="w-[20%] flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                stroke="#2817E9"
                strokeWidth="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                stroke="#2817E9"
                strokeWidth="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className="w-[21.5rem]">
            <p className="text-xs font-medium">
              You have added a new appointment for
              <span className="underline text-[#009FE3] cursor-pointer">
                {" "}
                ADETUNJI, TOBI
              </span>{" "}
              for{" "}
              <span className="underline text-[#009FE3] cursor-pointer">
                AXA Mansard
              </span>
            </p>
            <p className="my-3 text-xs font-medium">
              Click here to get further information.
            </p>
            <p className="text-base font-medium underline text-[#009FE3] cursor-pointer">
              View information
            </p>
          </div>
        </div>}
      </div>

    {/* Appointments */}
      <div className=" border-b-4 ">
        <div className="flex gap-3 w-full py-3 px-2 items-center cursor-pointer" onClick={ () => {opened === 'appointments' ? setOpened(null) : setOpened('appointments') }}>
          <span className=" w-[2.3125rem] h-[1.4375rem] bg-[#2817E9] text-white rounded-[1.25rem] text-[0.75rem] flex items-center justify-center shrink-0 font-[500] leading-3">
            2
          </span>
          <span className="text-[1rem] font-[500] w-[80%] leading-4 capitalize">
            appointments
          </span>
          <span className=" leading 1">
           {opened === 'appointments' ? <MdOutlineKeyboardArrowUp  size={30}/> : <MdOutlineKeyboardArrowDown  size={30}/>}
          </span>
        </div>
       {opened === 'appointments' && <div className="flex gap-6 py-6">
          <div className="w-[20%] flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                stroke="#2817E9"
                strokeWidth="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                stroke="#2817E9"
                strokeWidth="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className="w-[21.5rem]">
            <p className="text-xs font-medium">
              You have added a new appointment for
              <span className="underline text-[#009FE3] cursor-pointer">
                {" "}
                ADETUNJI, TOBI
              </span>{" "}
              for{" "}
              <span className="underline text-[#009FE3] cursor-pointer">
                AXA Mansard
              </span>
            </p>
            <p className="my-3 text-xs font-medium">
              Click here to get further information.
            </p>
            <p className="text-base font-medium underline text-[#009FE3] cursor-pointer">
              View information
            </p>
          </div>
        </div>}
      </div>

    {/* Billing */}
      <div className=" border-b-4 ">
        <div className="flex gap-3 w-full py-3 px-2 items-center cursor-pointer" onClick={ () => {opened === 'billing' ? setOpened(null) : setOpened('billing') }}>
          <span className=" w-[2.3125rem] h-[1.4375rem] bg-[#2817E9] text-white rounded-[1.25rem] text-[0.75rem] flex items-center justify-center shrink-0 font-[500] leading-3">
            2
          </span>
          <span className="text-[1rem] font-[500] w-[80%] leading-4 capitalize">
            billing
          </span>
          <span className=" leading 1">
           {opened === 'billing' ? <MdOutlineKeyboardArrowUp  size={30}/> : <MdOutlineKeyboardArrowDown  size={30}/>}
          </span>
        </div>
       {opened === 'billing' && <div className="flex gap-6 py-6">
          <div className="w-[20%] flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                stroke="#2817E9"
                strokeWidth="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                stroke="#2817E9"
                strokeWidth="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className="w-[21.5rem]">
            <p className="text-xs font-medium">
              You have added a new appointment for
              <span className="underline text-[#009FE3] cursor-pointer">
                {" "}
                ADETUNJI, TOBI
              </span>{" "}
              for{" "}
              <span className="underline text-[#009FE3] cursor-pointer">
                AXA Mansard
              </span>
            </p>
            <p className="my-3 text-xs font-medium">
              Click here to get further information.
            </p>
            <p className="text-base font-medium underline text-[#009FE3] cursor-pointer">
              View information
            </p>
          </div>
        </div>}
      </div>

      {/* Partners */}

      <div className=" border-b-4 ">
        <div className="flex gap-3 w-full py-3 px-2 items-center cursor-pointer" onClick={ () => {opened === 'partners' ? setOpened(null) : setOpened('partners') }}>
          <span className=" w-[2.3125rem] h-[1.4375rem] bg-[#2817E9] text-white rounded-[1.25rem] text-[0.75rem] flex items-center justify-center shrink-0 font-[500] leading-3">
            2
          </span>
          <span className="text-[1rem] font-[500] w-[80%] leading-4 capitalize">
            partners
          </span>
          <span className=" leading 1">
           {opened === 'partners' ? <MdOutlineKeyboardArrowUp  size={30}/> : <MdOutlineKeyboardArrowDown  size={30}/>}
          </span>
        </div>
       {opened === 'partners' && <div className="flex gap-6 py-6">
          <div className="w-[20%] flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                stroke="#2817E9"
                strokeWidth="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                stroke="#2817E9"
                strokeWidth="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className="w-[21.5rem]">
            <p className="text-xs font-medium">
              You have added a new appointment for
              <span className="underline text-[#009FE3] cursor-pointer">
                {" "}
                ADETUNJI, TOBI
              </span>{" "}
              for{" "}
              <span className="underline text-[#009FE3] cursor-pointer">
                AXA Mansard
              </span>
            </p>
            <p className="my-3 text-xs font-medium">
              Click here to get further information.
            </p>
            <p className="text-base font-medium underline text-[#009FE3] cursor-pointer">
              View information
            </p>
          </div>
        </div>}
      </div>
    </div>
  );
}

export default Notification;
